import { watch, onUnmounted, type Ref } from 'vue';

let lockCount = 0;

function lock() {
  lockCount += 1;
  if (lockCount === 1) document.body.style.overflow = 'hidden';
}
function unlock() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) document.body.style.overflow = '';
}

/**
 * Bloque le scroll du <body> tant que la ref passée est vraie.
 * Compte les verrous actifs pour supporter plusieurs drawers ouverts en même temps
 * sans que la fermeture de l'un ne réactive le scroll prématurément.
 */
export function useBodyScrollLock(isOpen: Ref<boolean>) {
  let locked = false;

  watch(
    isOpen,
    (open) => {
      if (open && !locked) {
        locked = true;
        lock();
      } else if (!open && locked) {
        locked = false;
        unlock();
      }
    },
    { immediate: true },
  );

  onUnmounted(() => {
    if (locked) {
      locked = false;
      unlock();
    }
  });
}
